import type { FaireProductEntity } from "../../entity_types/product";

export const p_5dx9thfmvf: FaireProductEntity = {
  token: "p_5dx9thfmvf",
  type: "product",
  name: "Proud Source - Water Spring Alk Ph 8.1 - Case of 3-8/12 FZ",
  brandToken: "b_7xgwjjb7p6",
  brandName: "Everyday Supply Co",
  imageUrl:
    "https://cdn.faire.com/fastly/b7a6bcf81691843fdc0de4ffaf391e50f4ef77fc4eb4130e25f0da0b3e7c29f6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2da687cae4e5c935d038c4adbeb6a3661a9c70b36f609e7376559e5ad675bcb0.jpeg",
    "https://cdn.faire.com/fastly/08ee5ee62092a94787a944f95dbb5e2d41c9cc611c382d0d1a9a4895fb16be5c.jpeg",
  ],
  priceDollars: 60.68,
  description:
    "Quench your thirst with this refreshing natural alkaline spring water, offering a balanced pH of 8.1. Sourced directly from pristine springs in the USA, each bottle is packed with naturally occurring minerals and electrolytes to support your active lifestyle. This environmentally conscious choice comes in infinitely recyclable aluminum bottles, making it a sustainable option for those who care about the planet.\n\n * Alkaline pH 8.1 for optimal hydration \n * Contains naturally occurring minerals and electrolytes \n * Sourced and bottled in the USA \n * Packaged in eco-friendly, recyclable aluminum \n * Supports environmental initiatives with funds for outdoor cleanups \nEnjoy the crisp, clean taste while contributing to a better world with each sip.",
  tags: [],
  msrpDollars: 75.85,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:36.614Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
